export default {
    // Shared with master builder
    selectedItem: null,
    draggedElement: null,
    isDragMode: false,
    // Required for Survey Builder
    currentMenuTab: null,
    parentSection: null,
    parentColumn: null,
    emptyHoveredColumnId: null,
    parentElement: null,
    emailTarget: null
}